import React from 'react';

interface CopyrightProps {
  className?: string;
}

export const Copyright: React.FC<CopyrightProps> = ({ className }) => (
  <span className={className}>&copy; {new Date().getFullYear()} T.H.E.M. Labs LLC</span>
);
